<template>
  <div
    class="box cursor-pointer"
    @click.prevent="toggleDivision"
  >
    <div class="media">
      <div class="media-left">
        <span class="icon">
          <CheckboxMarked v-if="division.selected" />
          <CheckboxBlankOutline v-else/>
        </span>
      </div>
      <div class="media-content">
        <div class="content">
          <div class="division-info">
            <div class="info-left">
              <p><strong>{{ division.name }}</strong></p>
            </div>
            <div class="info-right">
              <p><strong>${{ formatPrice(division.price) }}</strong></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckboxBlankOutline from 'vue-material-design-icons/CheckboxBlankOutline.vue'
import CheckboxMarked from 'vue-material-design-icons/CheckboxMarked.vue'
import priceMixin from '@/mixins/price'

export default {
  name: 'DivisionItem',
  mixins: [priceMixin],
  components: {
    CheckboxBlankOutline,
    CheckboxMarked
  },
  props: {
    division: {
      type: Object,
      required: true,
      default: () => {
        return {
          name: 'N/A',
          selected: false,
          price: 0
        }
      }
    }
  },
  methods: {
    toggleDivision () {
      this.$emit('toggleDivision', { _id: this.division._id, selected: !this.division.selected })
    }
  }
}
</script>

<style lang="scss">
  .division-info{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
</style>
